export default __webpack_public_path__ + "static/media/bssLogo.a71c217a.png";